module.exports = __webpack_public_path__ + "static/img/third3_1_3.ca4a7883.jpg";